export { ProfileDetailPageComponent } from './profile-detail-page/profile-detail-page.component';
export { FeedbackPageComponent } from './feedback-page/feedback-page.component';
export { LogoutComponent } from './logout/logout.component';
export { InviteCodeComponent } from './invite-code/invite-code.component';
export { ProfilePageComponent } from './profile-page/profile-page.component';
export { ChangePasswordComponent } from './change-password/change-password.component';
export { GameInviteCodeComponent } from './game-invite-code/game-invite-code.component';
export { WithdrawChangeAccountComponent } from './withdraw-change-account/withdraw-change-account.component';